<div class="mat-form-title" [ngClass]="{disable: disabled}"
    [ngStyle]="{'text-align': xAlignment == '3' ? 'center' : xAlignment == '2' ? 'right' : 'left'}">
    <span *ngIf="required" class="required" [ngClass]="xAlignment == '2' ? 'pull-right flip' : 'pull-left flip'">
        <pep-icon name="system_must">
        </pep-icon>
    </span>
    <mat-label *ngIf="showTitle" class="body-xs" [ngStyle]="{'max-width': maxFieldCharacters > 0 ? '85%' : '100%'}">
        {{ label }}</mat-label>

    <span *ngIf="maxFieldCharacters > 0" class="body-xs"
        [ngClass]="{'pull-right': xAlignment == '1' || xAlignment == '0', 'pull-left': xAlignment == '2'}">&nbsp;{{ inputLength || 0 }}/{{ maxFieldCharacters }}</span>
</div>
